import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetWiresMentioningOfOrganisation(organisation, limit) {
  return useAxios({
    cache: { ignoreCache: true },
    url: `/api/v1/wires/mention_of/organisation/${encodeURIComponent(organisation)}`,
    method: 'GET',
    params: {
      top: limit,
      search_query_id: window.Livewire?.request?.searchQuery?.id,
    },
  }, { manual: true });
}
